// menu service interface used for handling menus items on left-side navigation bar

import {Observable} from "rxjs";
import {NavItem} from "libComm";

export interface IMenuService
{
	// getAppVersion(): string; // application version (e.g. "x.y.z")
	// getBackendVersionObs(): Observable<string>; // back-end version
	getMenuItemsObs(): Observable<NavItem[]>;  // return an array of menu items
}